<template>
  <div>
  </div>
</template>

<script>
import axios from '@/axios'
import router from '@/router'
import auth from '@/services/authService'

const dialogs = {
  expired: (error) => {
    return {
      color: "danger", 
      title: "Session Expired.",
      text: "Opps, you have missed the chance! Try to contact the owner to resend invitation.",
      accept:() => {
        router.push('/signup')
      },
      close:() => {
        router.push('/signup')
      }
    }
  }
}

export default {
  components: {

  },
  data () {
    return {
    }
  },
  beforeMount(){
    const headers = { 'Content-Type' : 'application/json' }
      axios.post('/auth/invite_token_validity', { token: this.token }, {
        headers
      }).then((res) => {
        if(res.data.data === 'expired'){
          this.$vs.dialog(dialogs.expired())
        }else {
					localStorage.setItem('token',this.token)
        	this.$router.push({ path: '/signup' })
        }
      }).catch((err) => { console.log(err) })
    
  },
  computed: {
    token(){
      return decodeURIComponent(this.$route.path.replace('/invite/',''))
    }
  },
  methods: {
  }
}
</script>

<style scoped>
* {
    padding:0;
    margin: 0;
    box-sizing: border-box;
}

body {
  display:flex;
}

.container {
    width: 50vw;
    height: 50vw;
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-gap: 28rem;
    padding: 0 2rem;
    
}

.img{
    display: flex;
    justify-content: flex-end;
    align-items: center
}
/*
.img img{
   width: 600px; 
} */

.forgetpass-container {
    display: flex;
    place-items: center;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 80px;
    margin-bottom: 30px;
}

.form{
    width:360px;
}

.logo {
    width: 150px;
    place-items: center;
}

.input-div{
    display: grid;
    margin: 25px 0;
    padding: 5px 0;
    border-bottom: 2px solid #F9278E;
}


.input-div > div {
    position: relative;
    height: 45px;

}

.input-div > div h5{
    position:absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #f9278e;
    display: none;
    font-size: 18px;
    transition: .3s;
}

/* .input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem 0.7rem;
    font-size: 1.2rem;
    color: #555555;
} */


a{
  display: block;
  text-align: right;
  text-decoration: none;
  color: #999999;
  font-size: 0.9rem;
  transition: 0.3s;
  cursor: pointer;
}

a:hover{
  color:#f9278e;
}

@media screen and (max-width: 1050px) {
    .container{
        grid-gap: 6rem;
    }
}

@media screen and (max-width: 1000px) {
    .form{
        width: 290px;
    }

    .form h3{
        font-size: 1.2rem;
    }
    /* .img img{
        width: 400px;
    } */
}

@media screen and (max-width: 900px) {
    /* .img{
        display:none;
    } */
    .container{
        grid-template-columns: 1fr;
    }
    .forgetpass-container{
        justify-content: center;
    }
}
</style>
